/**
 * Ajido Warranty Web v5 — Frontend state machine (re-skin native + tab Tra cứu)
 *
 * Contract API: D:\WORKSPACE\warranty-api\docs\search-api-contract.md (chốt 2026-08-18)
 *
 * 2 tab:
 *   - Kích hoạt : #kich-hoat → #ket-qua → #dang-ky → #dang-ky-2 → #hoan-tat
 *   - Tra cứu   : #tra-cuu → #ds-bao-hanh → #chi-tiet
 *
 * Hash cũ được alias (replaceState): #lookup→#kich-hoat, #result→#ket-qua,
 * #form→#dang-ky, #success→#hoan-tat.
 *
 * Nguyên tắc:
 *   - setHash() là nguồn DUY NHẤT kích hoạt render (routeToState).
 *   - render() chạy TRƯỚC khi section được bỏ hidden.
 *   - Route thiếu element → bỏ qua im lặng, không chết cả IIFE.
 *   - KHÔNG BAO GIỜ đưa SĐT vào URL/hash.
 *   - Mã bảo hành do SERVER cấp (warranty_code trong response /activate) —
 *     đã bỏ generate mã phía client.
 */

(function () {
  'use strict';

  /* =====================================================================
   * MOCK MODE — test giao diện KHÔNG cần backend:
   *   1. Đổi USE_MOCK = true (chỉ 1 dòng này).
   *   2. Dữ liệu thử:
   *      Tab Kích hoạt : nhập bất kỳ (VD "VN261059728287N") → tìm thấy đơn
   *                      nhập "DAKICHHOAT" → blocked already_activated (+ nút Xem phiếu)
   *                      nhập "KHONGCO"    → not_found → form tự nhập
   *      Tab Tra cứu   : "WAJ-2026-7K3M9P" → 1 phiếu → thẳng chi tiết
   *                      "0987654321"      → 2 phiếu → danh sách
   *                      "KHONGCO"         → empty-state trong tab
   *                      mã đơn bất kỳ     → đơn chưa đăng ký (not_registered)
   *   3. Nhớ trả USE_MOCK = false trước khi deploy.
   * ===================================================================== */
  const USE_MOCK = false;

  const app = document.getElementById('warranty-app');
  if (!app) return;

  const API_BASE = app.dataset.apiBase || '/apps/warranty';
  const ZALO_URL = app.dataset.zalo || 'https://zalo.me/1885621654350466464';

  const CHANNEL_MAP = { shopee: 'Shopee', tiktok_shop: 'TikTok Shop', sapo: 'Web/POS Sapo', manual: 'Thủ công', gsheet: 'Import' };

  const ICON_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="m7.5 4.27 9 5.15"/>'
    + '<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/>'
    + '<path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>';
  const ICON_CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
  const ICON_COPY = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
  const ICON_SEARCH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';

  /* Icon kênh bán (02/09/2026) — vuông bo góc màu thương hiệu, vẽ tay 24×24.
   * Nốt nhạc TikTok lấy path của simple-icons (CC0), thu 58% đặt giữa ô. */
  const CHANNEL_ICONS = {
    shopee: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="6" fill="#EE4D2D"/>'
      + '<path d="M8.6 9.2V8.4a3.4 3.4 0 0 1 6.8 0v.8" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/>'
      + '<path d="M6.6 9.2h10.8l.8 8.9a1.8 1.8 0 0 1-1.8 1.9H7.6a1.8 1.8 0 0 1-1.8-1.9z" fill="#fff"/>'
      + '<path d="M10.1 15.9c.4.6 1.1 1 1.9 1 1 0 1.8-.6 1.8-1.4 0-1.8-3.6-.9-3.6-2.8 0-.8.8-1.4 1.8-1.4.7 0 1.3.3 1.7.8" fill="none" stroke="#EE4D2D" stroke-width="1.2" stroke-linecap="round"/></svg>',
    tiktok_shop: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="6" fill="#141414"/>'
      + '<g transform="translate(5 5) scale(.58)"><path fill="#fff" d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></g></svg>',
    sapo: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="6" fill="#0F6E56"/>'
      + '<path d="M6 10.5 7.2 6.5h9.6l1.2 4M6 10.5h12M7 10.5V18h10v-7.5M10 18v-4h4v4" fill="none" stroke="#fff" stroke-width="1.5" stroke-linejoin="round"/></svg>',
    manual: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="6" fill="#DED9CD"/>'
      + '<path d="M7 17.5l.6-2.6L15 7.5a1.6 1.6 0 0 1 2.3 0l.2.2a1.6 1.6 0 0 1 0 2.3L10.1 17z" fill="none" stroke="#5C574D" stroke-width="1.5" stroke-linejoin="round"/></svg>',
    gsheet: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="6" fill="#1E7F4E"/>'
      + '<path d="M6.5 6.5h11v11h-11zM6.5 10.2h11M6.5 13.8h11M10.2 6.5v11" fill="none" stroke="#fff" stroke-width="1.4"/></svg>'
  };
  const ICON_CHANNEL_DEFAULT = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect width="24" height="24" rx="6" fill="#DED9CD"/>'
    + '<path d="M8.6 9.2V8.4a3.4 3.4 0 0 1 6.8 0v.8M6.6 9.2h10.8l.8 8.9a1.8 1.8 0 0 1-1.8 1.9H7.6a1.8 1.8 0 0 1-1.8-1.9z" fill="none" stroke="#5C574D" stroke-width="1.5" stroke-linejoin="round"/></svg>';

  /* ===== State + sessionStorage (TTL 30 phút) ============================ */
  const STORAGE_KEY = 'ajido_warranty_v1';
  const STORAGE_TTL = 30 * 60 * 1000;

  function defaultState() {
    return {
      version: 1,
      savedAt: Date.now(),
      // nhánh kích hoạt
      ref: null,
      refType: null,          // ref_type từ /lookup | 'manual' | 'no_code'
      lookupResult: null,     // response /lookup
      warrantyId: null,       // warranty_code SERVER cấp (sau /activate)
      step: 1,
      activateResult: null,   // response /activate
      activated: false,       // cờ chống gửi /activate lần 2 khi Back
      customer: null,
      notFoundMiss: 0,        // đếm số lần /lookup trả not_found liên tiếp
      // nhánh tra cứu
      searchQuery: null,
      searchResult: null,     // response /search
      detail: null,           // {kind:'activation', activation} | {kind:'not_registered', data}
      // lead từ chatbot Zalo OA (?lead=<token> trên URL) — điền sẵn bước 1 + gửi kèm /activate
      zaloLeadToken: null,
      zaloLead: null,         // { full_name, phone } từ GET /zalo/lead/<token>
      pick: null,             // { product_code, product_name } chọn ở ô sản phẩm (nhánh không có mã)
    };
  }

  let S = defaultState();

  function saveState() {
    try {
      S.savedAt = Date.now();
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(S));
    } catch (e) { /* private mode — bỏ qua */ }
  }

  function loadState() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      const d = JSON.parse(raw);
      if (d && d.version === 1 && typeof d.savedAt === 'number' && (Date.now() - d.savedAt) < STORAGE_TTL) {
        S = Object.assign(defaultState(), d);
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) { /* JSON hỏng — bỏ qua */ }
  }

  /* ===== Lead từ chatbot Zalo OA ========================================== */
  const LEAD_TOKEN_RE = /^[A-Za-z0-9_-]{32}$/;

  // Nút "Kích hoạt bảo hành ngay" trong chatbot mở trang với ?lead=<token>. Cất token vào
  // state rồi xoá khỏi URL (không để token nằm lại trong lịch sử/chia sẻ link), sau đó
  // lấy tên + SĐT để điền sẵn. Không có ?lead= → không đổi gì.
  function captureZaloLead() {
    let token = null;
    try { token = new URLSearchParams(location.search || '').get('lead'); } catch (e) { token = null; }
    if (token && LEAD_TOKEN_RE.test(token)) {
      S.zaloLeadToken = token;
      S.zaloLead = null;
      saveState();
      try { history.replaceState(null, '', (location.pathname || '') + (location.hash || '#kich-hoat')); } catch (e) { /* bỏ qua */ }
    }
    if (S.zaloLeadToken && !S.zaloLead) fetchZaloLead(S.zaloLeadToken);
  }

  async function fetchZaloLead(token) {
    try {
      const res = await apiFetch('/zalo/lead/' + encodeURIComponent(token));
      if (res.ok && res.data && (res.data.full_name || res.data.phone)) {
        S.zaloLead = { full_name: res.data.full_name || '', phone: res.data.phone || '' };
      } else if (res.status === 404) {
        S.zaloLeadToken = null; S.zaloLead = null; // hết hạn/đã dùng → về luồng thường
      }
      saveState();
      prefillFromZaloLead();
    } catch (e) { /* mạng lỗi — giữ token, không điền */ }
  }

  // Chỉ điền ô trống; khách vẫn sửa được.
  function prefillFromZaloLead() {
    if (!S.zaloLead) return;
    const n = document.getElementById('full_name');
    if (n && !n.value && S.zaloLead.full_name) n.value = S.zaloLead.full_name;
    const p = document.getElementById('phone');
    if (p && !p.value && S.zaloLead.phone) p.value = S.zaloLead.phone;
  }

  function resetActivation() {
    S.ref = null; S.refType = null; S.lookupResult = null;
    S.warrantyId = null; S.step = 1;
    S.activateResult = null; S.activated = false; S.customer = null;
    S.pick = null;
  }

  /* ===== API (fetch thật hoặc mock) ====================================== */
  async function apiFetch(path, opts) {
    if (USE_MOCK) return mockApi(path, opts);
    const res = await fetch(API_BASE + path, Object.assign({ headers: { 'Accept': 'application/json' } }, opts || {}));
    let data = null;
    try { data = await res.json(); } catch (e) { /* body rỗng */ }
    return { ok: res.ok, status: res.status, data: data };
  }

  /* ===== Routing ========================================================= */
  const ALIAS = { lookup: 'kich-hoat', result: 'ket-qua', form: 'dang-ky', success: 'hoan-tat' };

  function sec(name) { return app.querySelector('[data-state="' + name + '"]'); }

  const ROUTES = {
    'kich-hoat':   { tab: 'kich-hoat', el: sec('kich-hoat'),   render: renderLookup },
    'ket-qua':     { tab: 'kich-hoat', el: sec('ket-qua'),     render: renderResult,  guard: function () { return !!(S.lookupResult && S.lookupResult.order); }, fallback: 'kich-hoat' },
    'dang-ky':     { tab: 'kich-hoat', el: sec('dang-ky'),     render: renderForm,    guard: function () { return !!S.lookupResult; }, fallback: 'kich-hoat' },
    'dang-ky-2':   { tab: 'kich-hoat', el: sec('dang-ky-2'),   render: renderStep2,   guard: function () { return !!S.activateResult; }, fallback: 'kich-hoat' },
    'hoan-tat':    { tab: 'kich-hoat', el: sec('hoan-tat'),    render: renderSuccess, guard: function () { return !!S.activateResult; }, fallback: 'kich-hoat' },
    'tra-cuu':     { tab: 'tra-cuu',   el: sec('tra-cuu'),     render: renderSearch },
    'ds-bao-hanh': { tab: 'tra-cuu',   el: sec('ds-bao-hanh'), render: renderList,    guard: function () { return !!(S.searchResult && S.searchResult.status === 'found' && (S.searchResult.activations || []).length > 0); }, fallback: 'tra-cuu' },
    'chi-tiet':    { tab: 'tra-cuu',   el: sec('chi-tiet'),    render: renderDetail,  guard: function () { return !!S.detail; }, rehydrate: rehydrateDetail, fallback: 'tra-cuu' },
  };

  function parseHash() {
    const raw = (location.hash || '#kich-hoat').replace(/^#/, '');
    const parts = raw.split('?');
    return { name: parts[0], params: new URLSearchParams(parts[1] || '') };
  }

  function setActiveTab(tabName) {
    document.querySelectorAll('.w5-tab').forEach(function (t) {
      t.setAttribute('aria-selected', String(t.dataset.tab === tabName));
    });
  }

  let booted = false;
  let routeSeq = 0;

  async function routeToState() {
    const seq = ++routeSeq;
    const parsed = parseHash();
    let name = parsed.name;
    const params = parsed.params;

    // Alias hash cũ → hash mới (giữ nguyên query params)
    if (ALIAS[name]) {
      name = ALIAS[name];
      const qs = params.toString();
      history.replaceState(null, '', '#' + name + (qs ? '?' + qs : ''));
    }

    let route = ROUTES[name];
    if (!route || !route.el) {
      // route lạ / template thiếu section → về mặc định
      name = 'kich-hoat';
      route = ROUTES[name];
      history.replaceState(null, '', '#kich-hoat');
      if (!route || !route.el) return; // markup app không có — thoát im lặng
    }

    if (route.guard && !route.guard()) {
      let rescued = false;
      if (route.rehydrate) {
        try { rescued = await route.rehydrate(params); } catch (e) { rescued = false; }
        if (seq !== routeSeq) return; // có điều hướng mới trong lúc chờ fetch
      }
      if (!rescued) {
        showToast('Phiên làm việc đã hết hạn hoặc thiếu dữ liệu — vui lòng thao tác lại.');
        name = route.fallback || 'kich-hoat';
        route = ROUTES[name] || ROUTES['kich-hoat'];
        history.replaceState(null, '', '#' + name);
        if (!route || !route.el) return;
      }
    }

    // render TRƯỚC khi bỏ hidden
    try {
      if (route.render) route.render(params);
    } catch (err) {
      console.error('[warranty] render error:', err);
    }

    for (const key of Object.keys(ROUTES)) {
      const r = ROUTES[key];
      if (!r.el) continue;
      r.el.hidden = (key !== name);
    }
    setActiveTab(route.tab);

    if (booted) {
      document.getElementById('khu-vuc-bao-hanh')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    booted = true;
  }

  // Nguồn DUY NHẤT kích hoạt render.
  function setHash(hash, opts) {
    const target = hash || '#kich-hoat';
    if (opts && opts.replace) {
      history.replaceState(null, '', target);
    } else if (location.hash !== target) {
      history.pushState(null, '', target);
    }
    routeToState();
  }

  // KHÔNG BAO GIỜ đưa SĐT vào URL — nếu ref dạng SĐT thì hash không mang param.
  function hashForDetail(ref) {
    if (!ref || isPhoneLike(ref)) return '#chi-tiet';
    return '#chi-tiet?wid=' + encodeURIComponent(ref);
  }

  /* ===== Rehydrate #chi-tiet?wid=... (mở link trực tiếp / F5) ============ */
  async function rehydrateDetail(params) {
    const q = String(params.get('wid') || params.get('q') || '').trim();
    if (!q || isPhoneLike(q)) return false;
    try {
      const res = await apiFetch('/search?q=' + encodeURIComponent(q));
      if (!res.ok || !res.data) return false;
      const data = res.data;
      if (data.status === 'found' && Array.isArray(data.activations) && data.activations.length > 0) {
        const match = data.activations.find(function (a) {
          return String(a.warranty_code || '').toUpperCase() === q.toUpperCase();
        }) || data.activations[0];
        S.searchQuery = q; S.searchResult = data;
        S.detail = { kind: 'activation', activation: match };
        saveState();
        return true;
      }
      if (data.status === 'not_registered') {
        S.searchQuery = q; S.searchResult = data;
        S.detail = { kind: 'not_registered', data: data };
        saveState();
        return true;
      }
    } catch (e) { /* mất mạng — rơi về fallback */ }
    return false;
  }

  /* ===== LUỒNG KÍCH HOẠT ================================================= */
  const lookupForm = document.getElementById('lookup-form');
  const refInput = document.getElementById('ref-input');

  lookupForm?.addEventListener('submit', async function (e) {
    e.preventDefault();
    const ref = (refInput?.value || '').trim();
    if (!ref || ref.length < 3) {
      showHelperError(refInput, 'Vui lòng nhập mã đơn hoặc mã vận đơn');
      return;
    }
    await doLookup(ref);
  });

  document.getElementById('no-code-link')?.addEventListener('click', function (e) {
    e.preventDefault();
    // Giữ token của phiên trước LẠI TRƯỚC KHI reset — resetActivation() xoá S.ref.
    const tokenCu = (S.ref && /^NOCODE-/.test(S.ref) && !S.activated) ? S.ref : null;
    resetActivation();
    S.refType = 'no_code';
    S.lookupResult = { status: 'no_code' };
    // Server BẮT BUỘC external_ref + warranty_id là chuỗi (validation.ts:
    // z.string().min(1) / min(3)) kể cả nhánh không có mã, và dùng
    // external_ref để sinh order_id = sha256(phone|external_ref). Thiếu là
    // 400 VALIDATION_ERROR → cả nhánh "Tôi không có mã" chết.
    // Tiền tố NOCODE- chứ KHÔNG phải WAJ-: mã WAJ thật do server cấp
    // (gen_warranty_code), client bịa mã trông giống là gây nhầm cho CSKH.
    // ⚠️ order_id server = sha256(phone|external_ref), nên token ĐỔI là đơn ĐỔI.
    // Phải TÁI SỬ DỤNG token cũ nếu phiên này đã sinh mà chưa kích hoạt xong:
    // khách bấm lại link sau khi rớt mạng mà mint token mới sẽ đẻ ra phiếu bảo
    // hành THỨ HAI với mã WAJ khác cho cùng một cái máy.
    S.ref = tokenCu || ('NOCODE-' + Math.random().toString(36).slice(2, 10).toUpperCase());
    S.warrantyId = S.ref;
    saveState();
    setHash('#dang-ky');
  });

  async function doLookup(ref) {
    const btn = lookupForm?.querySelector('button[type="submit"]');
    btn?.classList.add('is-loading');
    if (btn) btn.disabled = true;

    try {
      const res = await apiFetch('/lookup?ref=' + encodeURIComponent(ref));
      const data = res.data || {};

      if (!res.ok) {
        showError({ title: 'Có lỗi khi tra cứu', message: (data.error && data.error.message_vi) || 'Vui lòng thử lại sau ít phút.' });
        return;
      }

      if (data.status === 'blocked') {
        if (data.blocked_reason === 'already_activated') {
          // Contract mục 1: response thêm action {type:'switch_to_search', q, label_vi}
          const act = data.action;
          showError({
            title: 'Đơn đã được kích hoạt',
            message: data.message_vi,
            showCsk: true,
            action: (act && act.type === 'switch_to_search' && act.q)
              ? { label: act.label_vi || 'Xem phiếu bảo hành', onClick: function () { startSearch(act.q); } }
              : null,
          });
        } else {
          const map = {
            // Không khẳng định "chưa giao": dữ liệu đơn đồng bộ trễ so với sàn, khách hay tra
            // ngay lúc vừa nhận hàng (vụ vận đơn 862402116118, 30/09/2026). Câu chi tiết do API gửi.
            not_delivered_yet: { title: 'Chưa ghi nhận giao hàng', csk: true },
            order_cancelled: { title: 'Đơn đã huỷ hoặc hoàn', csk: true },
            no_products_in_policy: { title: 'Sản phẩm không có chương trình bảo hành', csk: true },
          };
          const info = map[data.blocked_reason] || { title: 'Không thể kích hoạt', csk: true };
          showError({ title: info.title, message: data.message_vi, showCsk: info.csk });
        }
        return;
      }

      if (data.status === 'not_found') {
        S.notFoundMiss = (S.notFoundMiss || 0);

        if (window.AjidoScan && window.AjidoScan.notFoundNext(S.notFoundMiss) === 'stay') {
          // resetActivation() xoá S.ref/S.lookupResult/... nhưng KHÔNG đụng
          // notFoundMiss — phải xoá lookup cũ ở đây như mọi nhánh not_found
          // khác, không thì S.lookupResult của lần tra trước còn sống, khiến
          // guard route #ket-qua/#dang-ky vẫn qua và Back có thể lòi ra đơn
          // đã tra trước đó.
          var missSoFar = S.notFoundMiss;
          resetActivation();
          S.notFoundMiss = missSoFar + 1;
          saveState();
          showToast('Không tìm thấy đơn với mã này. Kiểm tra lại mã theo hướng dẫn bên dưới, hoặc chọn "Không có mã đơn".', 6000);
          window.AjidoScan.guide.open(document);
          refInput?.focus();
          refInput?.select();
          return;
        }

        resetActivation();
        S.notFoundMiss = 0;
        S.ref = ref; S.refType = 'manual'; S.lookupResult = data; S.step = 1;
        // warranty_id là trường BẮT BUỘC của POST /activate (z.string().min(3)).
        // /lookup đã trả sẵn `warranty_id: ref` trong response not_found — quên đọc
        // là cả nhánh manual ăn 400 VALIDATION_ERROR, đúng lỗi nhánh no_code từng dính.
        S.warrantyId = data.warranty_id || ref;
        saveState();
        setHash('#dang-ky');
        return;
      }

      // found → màn kết quả (read-only) trước
      resetActivation();
      S.notFoundMiss = 0;
      S.ref = ref;
      S.refType = data.ref_type || null;
      S.lookupResult = data;
      S.warrantyId = data.warranty_id || null; // nếu server có sẵn; không thì cấp sau /activate
      S.step = 1;
      saveState();
      setHash('#ket-qua');

    } catch (err) {
      console.error(err);
      showToast('Mất kết nối. Vui lòng thử lại.');
    } finally {
      btn?.classList.remove('is-loading');
      if (btn) btn.disabled = false;
    }
  }

  function renderLookup() {
    // Section tĩnh trong Liquid — không có gì phải render động.
  }

  /* ----- màn kết quả tra đơn (read-only) ----- */
  function renderResult() {
    const box = document.getElementById('result-content');
    const lr = S.lookupResult;
    if (!box || !lr || !lr.order) return;

    const order = lr.order;
    const items = order.items || [];
    let html = '';

    if (S.warrantyId) {
      html += '<div class="w5-code"><div><div class="w5-code-l">Mã bảo hành</div>'
        + '<div class="w5-code-v">' + escapeHtml(S.warrantyId) + '</div></div></div>';
    }

    html += '<dl class="w5-rows">'
      + rowHtml('Kênh', channelBadge(order))
      + row('Ngày giao', order.delivered_on ? formatDate(order.delivered_on) : '—')
      + row('Người nhận', (order.masked_name || '—') + (order.province ? ' · ' + order.province : ''))
      + row('SĐT đăng ký', order.masked_phone || '—')
      + '</dl>';

    html += '<span class="w5-eyebrow" style="margin-bottom:4px">' + items.length + ' sản phẩm trong đơn</span>';
    for (const item of items) {
      const badge = item.expired
        ? '<span class="w5-badge w5-badge--exp">Đã hết hạn</span>'
        : '<span class="w5-badge w5-badge--ok">Còn hiệu lực</span>';
      const meta = item.expired
        ? 'Hết bảo hành ngày ' + formatDate(item.warranty_end)
        : 'Bảo hành ' + item.warranty_months + ' tháng · còn ' + item.days_remaining + ' ngày · đến ' + formatDate(item.warranty_end);
      html += '<div class="w5-item">' + itemThumb(item)
        + '<div class="w5-item-b"><div class="w5-item-t">' + escapeHtml(item.product_name) + ' ' + badge + '</div>'
        + '<div class="w5-item-m">' + escapeHtml(meta) + '</div></div></div>';
    }

    const allExpired = items.length > 0 && items.every(function (i) { return i.expired; });
    const ctaText = allExpired ? 'Lưu hồ sơ (đã hết hạn)' : 'Kích hoạt bảo hành cho đơn này';
    html += '<button type="button" id="result-activate-btn" class="w5-btn w5-btn--w" style="margin-top:28px">' + ctaText + '</button>';
    html += '<div class="w5-link-row"><a href="#kich-hoat" class="w5-link">Tra cứu đơn khác</a></div>';

    box.innerHTML = html;

    document.getElementById('result-activate-btn')?.addEventListener('click', function () {
      S.step = 1;
      saveState();
      setHash('#dang-ky');
    });
  }

  /* ----- form đăng ký (bước 1) ----- */
  function currentPath() {
    const lr = S.lookupResult || {};
    if (lr.status === 'found') return 'matched';
    if (S.refType === 'no_code') return 'no_code';
    return 'manual';
  }

  function renderForm() {
    const box = document.getElementById('form-content');
    if (!box) return;

    const path = currentPath();
    const backLink = document.getElementById('back-to-result');
    if (backLink) backLink.hidden = (path !== 'matched');

    // Back sau khi đã POST thành công → chặn gửi lần 2 (cờ trong state)
    if (S.activated) {
      box.innerHTML = '<div class="w5-warnbox">Đơn này đã được kích hoạt trong phiên làm việc hiện tại — không thể gửi lại lần nữa.</div>'
        + '<button type="button" id="goto-success-btn" class="w5-btn w5-btn--w">Xem kết quả kích hoạt</button>'
        + '<div class="w5-link-row"><button type="button" class="w5-link" id="form-reset-link">Kích hoạt đơn khác</button></div>';
      document.getElementById('goto-success-btn')?.addEventListener('click', function () { setHash('#hoan-tat'); });
      document.getElementById('form-reset-link')?.addEventListener('click', function () {
        resetActivation();
        if (refInput) refInput.value = '';
        saveState();
        setHash('#kich-hoat');
      });
      return;
    }

    let html = '';

    if (path === 'matched') {
      const order = (S.lookupResult && S.lookupResult.order) || {};
      const items = order.items || [];
      const maskedName = order.masked_name || '';
      const maskedPhone = order.masked_phone || '';
      const summary = channelLabel(order) + ' · ' + (S.ref || '') + ' · ' + items.length + ' sản phẩm';

      html += '<div class="w5-code w5-code--fill"><div><div class="w5-code-l">Đơn hàng</div>'
        + '<div class="w5-code-v w5-code-v--sm">' + escapeHtml(summary) + '</div></div></div>';

      html += field('full_name', 'text', 'Họ và tên',
        maskedName ? 'Tùy chọn · đăng ký: ' + maskedName : 'Tùy chọn',
        maskedName || 'Nguyễn Văn A', false);
      html += field('phone', 'tel', 'Số điện thoại',
        maskedPhone ? 'Bắt buộc · đăng ký: ' + maskedPhone : 'Bắt buộc',
        '0987654321', true, 'Dùng để CSKH tra cứu bảo hành khi bạn cần sửa/đổi sản phẩm.');
    } else {
      if (path === 'manual') {
        html += '<div class="w5-warnbox">Không tìm thấy đơn này trong hệ thống. Có thể là đơn ngoài Ajido hoặc đơn cũ. '
          + 'Bạn có thể tự nhập thông tin hoặc <a href="' + ZALO_URL + '" target="_blank" rel="noopener">liên hệ Zalo OA</a>.</div>';
      } else {
        html += '<div class="w5-code w5-code--fill"><div><div class="w5-code-l">Mã bảo hành</div>'
          + '<div class="w5-code-v w5-code-v--sm">Sẽ được cấp ngay sau khi kích hoạt</div></div></div>';
      }

      html += '<div class="w5-field" id="product-field">' + productFieldHtml() + '</div>';

      html += '<div class="w5-field">'
        + '<label class="w5-field-label" for="purchase_date"><span>Ngày mua / nhận hàng</span><span class="w5-req">Bắt buộc</span></label>'
        + '<input type="date" id="purchase_date" class="w5-input" max="' + todayStr() + '" required>'
        + '</div>';

      html += field('full_name', 'text', 'Họ và tên', 'Tùy chọn', 'Nguyễn Văn A', false);
      html += field('phone', 'tel', 'Số điện thoại', 'Bắt buộc', '0987654321', true,
        'Dùng để CSKH tra cứu bảo hành khi bạn cần sửa/đổi sản phẩm.');
    }

    // Email + consent nằm ở BƯỚC 1 vì đây là lượt POST /activate duy nhất.
    // Bước 2 chạy SAU khi đã kích hoạt và không có endpoint cập nhật hồ sơ, nên
    // email nhập ở đó không đi đâu cả — khách sẽ không bao giờ nhận được mail.
    html += field('email', 'email', 'Email', 'Không bắt buộc', 'ban@example.com', false,
      'Dùng để gửi bản bảo hành điện tử kèm mã bảo hành.');
    html += '<label class="w5-checkbox"><input type="checkbox" id="allow_email_marketing" disabled>'
      + '<span>Nhận ưu đãi &amp; thông tin chăm sóc từ Ajido qua email</span></label>';

    html += '<button type="button" id="step1-submit" class="w5-btn w5-btn--w" style="margin-top:6px">Kích hoạt bảo hành</button>';

    box.innerHTML = html;
    prefillFromZaloLead();

    document.getElementById('step1-submit')?.addEventListener('click', function () { submitStep1(path); });
    if (path !== 'matched') {
      bindProductField();
      // Danh mục chưa tải (lần đầu vào form) → tải rồi dựng lại riêng ô sản phẩm.
      if (PRODUCTS === undefined) {
        loadProducts().then(function () {
          const f = document.getElementById('product-field');
          if (!f) return;
          f.innerHTML = productFieldHtml();
          bindProductField();
        });
      }
    }

    // Không có email thì ô consent vô nghĩa — khoá lại, và bỏ tick nếu khách
    // xoá email sau khi đã tick (nếu không sẽ gửi consent cho địa chỉ rỗng).
    const emailEl = document.getElementById('email');
    const consentEl = document.getElementById('allow_email_marketing');
    if (emailEl && consentEl) {
      const syncConsent = function () {
        const hasEmail = emailEl.value.trim() !== '';
        consentEl.disabled = !hasEmail;
        if (!hasEmail) consentEl.checked = false;
      };
      emailEl.addEventListener('input', syncConsent);
      syncConsent();
    }
  }

  function field(id, type, label, req, placeholder, isTel, hint) {
    return '<div class="w5-field">'
      + '<label class="w5-field-label" for="' + id + '"><span>' + escapeHtml(label) + '</span><span class="w5-req">' + escapeHtml(req) + '</span></label>'
      + '<input type="' + type + '" id="' + id + '" class="w5-input"'
      + (isTel ? ' inputmode="numeric" maxlength="15"' : '')
      + ' placeholder="' + escapeHtml(placeholder) + '">'
      + (hint ? '<p class="w5-hint">' + escapeHtml(hint) + '</p>' : '')
      + '</div>';
  }

  /* ===== Ô chọn sản phẩm có ảnh (nhánh không có mã đơn) =================== */
  // Thay <datalist> cũ (02/10/2026). Datalist gợi ý "Ajido S5 PRO"… — tên không
  // khớp warranty_policy nên 27/09–02/10 mọi lượt chọn đều lỗi 500, và datalist
  // không hiện được ảnh. Giờ danh mục lấy từ GET /products (tên + ảnh admin sửa
  // ở warranty-admin), khách chọn một dòng, FE gửi đúng product_code.
  // /products lỗi hoặc rỗng (backend cũ) → quay về ô gõ tay như trước.

  /** undefined = chưa tải · null = tải lỗi → ô gõ tay · mảng = có danh mục. */
  let PRODUCTS;
  let productsLoading = null;

  function loadProducts() {
    if (!productsLoading) {
      productsLoading = apiFetch('/products').then(function (res) {
        const list = res && res.ok && res.data && Array.isArray(res.data.products) ? res.data.products : [];
        PRODUCTS = list.filter(function (p) { return p && p.product_code && p.product_name; });
        if (!PRODUCTS.length) PRODUCTS = null;
      }).catch(function () { PRODUCTS = null; });
    }
    return productsLoading;
  }

  function findProduct(code) {
    return (PRODUCTS || []).find(function (p) { return p.product_code === code; }) || null;
  }

  /** Bỏ dấu + chữ thường để lọc "can s5" vẫn ra "Cân S5 PRO". */
  function foldText(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/đ/gi, 'd').toLowerCase();
  }

  const ICON_SCAN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5v14"/><path d="M8 5v14"/><path d="M12 5v14"/><path d="M17 5v14"/><path d="M21 5v14"/></svg>';
  const ICON_DOWN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  function scanButtonHtml() {
    return '<button type="button" class="w5-btn w5-btn--line" id="barcode-scan-btn" aria-label="Quét mã vạch trên hộp">'
      + ICON_SCAN + 'Quét</button>';
  }

  function productFieldHtml() {
    if (PRODUCTS === null) {
      // Ô gõ tay (khi không tải được danh mục) — giữ như bản cũ.
      return '<label class="w5-field-label" for="product_name_input"><span>Tên sản phẩm</span><span class="w5-req">Bắt buộc · gõ hoặc quét mã vạch</span></label>'
        + '<div class="w5-input-group">'
        + '<input type="text" id="product_name_input" class="w5-input" placeholder="VD: S5 Pro" required>'
        + scanButtonHtml() + '</div>'
        + '<p class="w5-hint">Gõ tên model in trên hộp · quét mã vạch hỗ trợ Chrome trên điện thoại.</p>';
    }

    const pick = S.pick && findProduct(S.pick.product_code);
    const loading = PRODUCTS === undefined;
    const face = pick
      ? itemThumb(pick) + '<span class="w5-pick-name">' + escapeHtml(pick.product_name) + '</span>'
      : '<span class="w5-pick-ph">' + (loading ? 'Đang tải danh sách sản phẩm…' : 'Chọn sản phẩm') + '</span>';

    let options = '';
    (PRODUCTS || []).forEach(function (p) {
      const selected = pick && pick.product_code === p.product_code;
      options += '<li role="option" aria-selected="' + (selected ? 'true' : 'false') + '"'
        + ' data-code="' + escapeHtml(p.product_code) + '"'
        + ' data-search="' + escapeHtml(foldText(p.product_name + ' ' + p.product_code)) + '">'
        + '<button type="button" class="w5-pick-opt" data-code="' + escapeHtml(p.product_code) + '">'
        + itemThumb(p)
        + '<span class="w5-pick-opt-b"><span class="w5-pick-opt-n">' + escapeHtml(p.product_name) + '</span>'
        + (p.warranty_months ? '<span class="w5-pick-opt-m">Bảo hành ' + escapeHtml(String(p.warranty_months)) + ' tháng</span>' : '')
        + '</span></button></li>';
    });

    return '<label class="w5-field-label" for="product-picker-btn"><span>Sản phẩm</span><span class="w5-req">Bắt buộc · chọn hoặc quét mã vạch</span></label>'
      + '<div class="w5-input-group">'
      + '<button type="button" id="product-picker-btn" class="w5-input w5-pick' + (pick ? ' is-picked' : '') + '"'
      + ' aria-haspopup="listbox" aria-expanded="false" aria-controls="product-picker-panel"' + (loading ? ' disabled' : '') + '>'
      + face + '<span class="w5-pick-caret">' + ICON_DOWN + '</span></button>'
      + scanButtonHtml() + '</div>'
      + '<div class="w5-pick-panel" id="product-picker-panel" hidden>'
      + '<input type="search" id="product-picker-q" class="w5-input w5-pick-q" placeholder="Tìm theo tên, VD: S5 Pro" autocomplete="off" aria-label="Tìm sản phẩm">'
      + '<ul class="w5-pick-list" id="product-picker-list" role="listbox" aria-label="Sản phẩm">' + options + '</ul>'
      + '<p class="w5-pick-empty" id="product-picker-empty" hidden>Không thấy sản phẩm này. Bấm <b>Quét</b> mã vạch trên hộp, hoặc '
      + '<a href="' + ZALO_URL + '" target="_blank" rel="noopener">nhắn Zalo OA</a> để CSKH kích hoạt giúp.</p>'
      + '</div>'
      + '<p class="w5-hint">Chọn đúng sản phẩm theo ảnh · hoặc bấm Quét mã vạch trên hộp (Chrome trên điện thoại).</p>';
  }

  function setPickerOpen(open) {
    const btn = document.getElementById('product-picker-btn');
    const panel = document.getElementById('product-picker-panel');
    if (!btn || !panel) return;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      const q = document.getElementById('product-picker-q');
      if (q) {
        q.value = ''; filterPicker('');
        // Điện thoại: không tự bật bàn phím — bàn phím che mất danh sách ảnh.
        const touch = typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;
        if (!touch) q.focus();
      }
    }
  }

  function filterPicker(query) {
    const list = document.getElementById('product-picker-list');
    if (!list) return;
    // So từng từ (đủ mọi từ là khớp): "can x8" ra "Cân ScanBody X8 ELITE".
    // Bỏ chữ "ajido" — tên trong danh mục không có thương hiệu.
    const words = foldText(query).split(/[^a-z0-9]+/).filter(function (w) { return w && w !== 'ajido'; });
    let shown = 0;
    Array.prototype.forEach.call(list.querySelectorAll('li[data-code]'), function (li) {
      const hay = li.getAttribute('data-search') || '';
      const hit = words.every(function (w) { return hay.indexOf(w) !== -1; });
      li.hidden = !hit;
      if (hit) shown++;
    });
    const empty = document.getElementById('product-picker-empty');
    if (empty) empty.hidden = shown > 0;
  }

  /** Chọn sản phẩm theo mã (từ danh sách hoặc từ quét mã vạch). */
  function pickProduct(code) {
    const p = findProduct(code);
    if (!p) return false;
    S.pick = { product_code: p.product_code, product_name: p.product_name };
    saveState();
    const f = document.getElementById('product-field');
    if (f) { f.innerHTML = productFieldHtml(); bindProductField(); }
    document.getElementById('product-picker-btn')?.focus();
    return true;
  }

  function bindProductField() {
    document.getElementById('barcode-scan-btn')?.addEventListener('click', function () {
      scanInto(
        {
          hint: 'Đưa mã vạch trên hộp sản phẩm vào khung',
          focusId: PRODUCTS ? 'product-picker-btn' : 'product_name_input',
          showGuide: false,
          // Hộp sản phẩm dùng cả EAN-8 lẫn EAN-13 — thiếu ean_8 thì
          // BarcodeDetector (Chrome Android) không đọc được các hộp nhỏ dùng
          // EAN-8, dù ZXing (fallback) vẫn đọc bình thường.
          formats: ['ean_13', 'ean_8', 'code_128'],
        },
        resolveBarcodeToProduct
      );
    });

    const btn = document.getElementById('product-picker-btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      const panel = document.getElementById('product-picker-panel');
      setPickerOpen(!!(panel && panel.hidden));
    });
    document.getElementById('product-picker-q')?.addEventListener('input', function (e) {
      filterPicker(e.target.value);
    });
    document.getElementById('product-picker-list')?.addEventListener('click', function (e) {
      const opt = e.target && typeof e.target.closest === 'function' ? e.target.closest('[data-code]') : null;
      if (opt) pickProduct(opt.getAttribute('data-code'));
    });
    document.getElementById('product-picker-panel')?.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { setPickerOpen(false); btn.focus(); }
    });
  }

  // Bấm ra ngoài ô chọn → đóng danh sách.
  document.addEventListener('click', function (e) {
    const panel = document.getElementById('product-picker-panel');
    if (!panel || panel.hidden) return;
    const field = document.getElementById('product-field');
    if (field && e.target && typeof field.contains === 'function' && field.contains(e.target)) return;
    setPickerOpen(false);
  });

  async function submitStep1(path) {
    if (S.activated) { setHash('#dang-ky-2'); return; } // chống double-submit

    const btn = document.getElementById('step1-submit');
    const fullName = (document.getElementById('full_name')?.value || '').trim();
    const phoneInput = document.getElementById('phone');
    const phoneRaw = (phoneInput?.value || '').trim();

    // Contract mục 4: customer.phone BẮT BUỘC, hợp lệ sau normalize — validate trước khi gửi
    const phone = normalizeVNPhone(phoneRaw);
    if (!phone) {
      showHelperError(phoneInput, 'Vui lòng nhập số điện thoại hợp lệ (VD: 0987654321)');
      return;
    }

    // Email là tuỳ chọn, nhưng schema server dùng z.string().email() — gửi địa chỉ
    // sai chính tả sẽ làm 400 CẢ lượt kích hoạt. Bắt lỗi tại đây để khách sửa
    // (hoặc xoá trống) thay vì nhận "Dữ liệu không hợp lệ" không rõ lý do.
    const emailInput = document.getElementById('email');
    const email = (emailInput?.value || '').trim();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showHelperError(emailInput, 'Email chưa đúng định dạng. Sửa lại hoặc để trống.');
      return;
    }
    const allowEmailMarketing = !!document.getElementById('allow_email_marketing')?.checked;

    let items = [];
    if (path === 'matched') {
      const deliveredISO = (S.lookupResult && S.lookupResult.order && S.lookupResult.order.delivered_on) || '';
      const deliveredDate = String(deliveredISO).slice(0, 10); // ISO timestamp → YYYY-MM-DD
      items = ((S.lookupResult && S.lookupResult.order && S.lookupResult.order.items) || []).map(function (it) {
        return { product_code: it.product_code, purchase_date: deliveredDate };
      });
    } else {
      const purchaseDate = document.getElementById('purchase_date')?.value || '';
      const pick = PRODUCTS && S.pick ? findProduct(S.pick.product_code) : null;
      const productName = pick
        ? pick.product_name
        : (document.getElementById('product_name_input')?.value || '').trim();
      if (!productName) {
        showToast('Vui lòng chọn sản phẩm');
        if (PRODUCTS) setPickerOpen(true);
        return;
      }
      if (!purchaseDate) {
        showToast('Vui lòng chọn ngày mua');
        return;
      }
      items = [pick
        ? { product_code: pick.product_code, product_name_input: pick.product_name, purchase_date: purchaseDate }
        : { product_name_input: productName, purchase_date: purchaseDate }];
    }

    btn?.classList.add('is-loading');
    if (btn) btn.disabled = true;

    try {
      const body = {
        source_path: path,                                    // matched | manual | no_code
        external_ref: S.ref || null,   // no_code: token NOCODE- sinh lúc bấm "Tôi không có mã"
        customer: { full_name: fullName, phone: phone },
        items: items,
      };
      if (S.warrantyId) body.warranty_id = S.warrantyId;      // chỉ khi lookup có sẵn; client KHÔNG tự sinh mã
      if (S.zaloLeadToken) body.zalo_lead_token = S.zaloLeadToken; // ghép UID Zalo ở server (tin về khung chat OA)
      // Không có email thì bỏ hẳn `optional` — đừng gửi allow_email_marketing
      // lơ lửng cho một địa chỉ không tồn tại.
      if (email) body.optional = { email: email, allow_email_marketing: allowEmailMarketing };

      const post = function (b) {
        return apiFetch('/activate', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(b),
        });
      };

      let res = await post(body);
      let data = res.data || {};
      let emailBiBo = false;

      // Email là trường TUỲ CHỌN — nó không được phép giết kết quả BẮT BUỘC.
      // Regex client không thể khớp hết z.string().email() của zod (zod chặn '..',
      // chấm đầu/cuối phần local, TLD phải >=2 chữ cái, chỉ ASCII), nên vẫn có
      // địa chỉ lọt client mà server từ chối. Gặp 400 thì gửi lại KHÔNG kèm
      // `optional`: khách vẫn kích hoạt được bảo hành, chỉ mất phần email.
      if (!res.ok && body.optional && data.error && data.error.code === 'VALIDATION_ERROR') {
        const bodyKhongEmail = Object.assign({}, body);
        delete bodyKhongEmail.optional;
        res = await post(bodyKhongEmail);
        data = res.data || {};
        emailBiBo = res.ok;
      }

      if (!res.ok) {
        if (data.error && data.error.code === 'ALREADY_ACTIVATED') {
          // Contract mục 2: 409 kèm action switch_to_search
          const act = data.action || (data.error && data.error.action);
          showError({
            title: 'Đơn đã được kích hoạt',
            message: data.error.message_vi,
            showCsk: true,
            action: (act && act.q)
              ? { label: act.label_vi || 'Xem phiếu bảo hành', onClick: function () { startSearch(act.q); } }
              : null,
          });
        } else if (data.error && data.error.code === 'PRODUCT_NOT_RESOLVED') {
          showError({ title: 'Chưa nhận ra sản phẩm', message: data.error.message_vi, showCsk: true });
        } else {
          showError({ title: 'Có lỗi', message: (data.error && data.error.message_vi) || 'Vui lòng thử lại sau ít phút.' });
        }
        return;
      }

      // Contract mục 3: server cấp warranty_code — hiển thị mã này, không sinh phía client
      S.activateResult = data;
      S.warrantyId = data.warranty_code || S.warrantyId || null;
      S.customer = { full_name: fullName, phone: phone };
      S.activated = true;
      S.step = 2;
      S.zaloLeadToken = null; S.zaloLead = null; // token dùng 1 lần — đã dùng
      saveState();
      setHash('#dang-ky-2');

      // Bảo hành đã kích hoạt xong; chỉ phần email bị bỏ. Báo cho khách biết để
      // họ không ngồi chờ mail, nhưng KHÔNG dựng modal lỗi — việc chính đã xong.
      if (emailBiBo) {
        showToast('Đã kích hoạt bảo hành. Email không hợp lệ nên chưa gửi được bản điện tử.');
      }

    } catch (err) {
      console.error(err);
      showToast('Mất kết nối. Vui lòng thử lại.');
    } finally {
      btn?.classList.remove('is-loading');
      if (btn) btn.disabled = false;
    }
  }

  /* ----- bước 2 (hash riêng #dang-ky-2) ----- */
  function renderStep2() {
    const box = document.getElementById('form2-content');
    if (!box) return;

    // Email + consent đã chuyển lên bước 1 (đi cùng POST /activate). Ở đây chỉ
    // còn địa chỉ + ngày sinh — 2 trường vẫn chưa có endpoint lưu (xem submitStep2).
    box.innerHTML = '<div class="w5-note" style="margin-top:0">'
      + '<h4>Voucher giảm 10% lần mua sau + quà sinh nhật</h4>'
      + '<p style="margin-bottom:0">Cho chúng tôi địa chỉ và ngày sinh để gửi voucher và quà tặng. Không bắt buộc.</p>'
      + '</div>'
      + field('step2_address', 'text', 'Địa chỉ chi tiết', 'Không bắt buộc', 'Số nhà, đường, phường', false)
      + '<div class="w5-field">'
      + '<label class="w5-field-label" for="step2_dob"><span>Ngày sinh</span><span class="w5-req">Để nhận quà sinh nhật</span></label>'
      + '<input type="date" id="step2_dob" class="w5-input" max="' + todayStr() + '">'
      + '</div>'
      + '<button type="button" id="step2-submit" class="w5-btn w5-btn--w">Hoàn tất</button>'
      + '<div class="w5-link-row"><a href="#hoan-tat" class="w5-link" id="step2-skip">Bỏ qua, xem kết quả</a></div>';

    document.getElementById('step2-submit')?.addEventListener('click', function () { submitStep2(false); });
    document.getElementById('step2-skip')?.addEventListener('click', function (e) {
      e.preventDefault();
      setHash('#hoan-tat');
    });
  }

  function submitStep2(skipOpt) {
    // v0.1: endpoint cập nhật hồ sơ defer sang v0.2 — chỉ thu thập + log (giữ behavior cũ)
    if (!skipOpt) {
      const address = (document.getElementById('step2_address')?.value || '').trim() || null;
      const dob = document.getElementById('step2_dob')?.value || null;
      console.log('Step 2 data (defer to v0.2):', { address: address, dob: dob });
    }
    setHash('#hoan-tat');
  }

  /* ----- màn thành công ----- */
  function renderSuccess() {
    const ar = S.activateResult;
    if (!ar) return;
    const records = ar.warranty_records || [];
    const allExpired = records.length > 0 && records.every(function (r) { return r.is_expired_at_activation; });

    document.getElementById('success-icon')?.classList.toggle('w5-tick--warn', allExpired);

    const title = document.getElementById('success-title');
    if (title) title.textContent = allExpired ? 'Đã ghi nhận hồ sơ' : 'Đã kích hoạt bảo hành';
    const subtitle = document.getElementById('success-subtitle');
    if (subtitle) {
      subtitle.textContent = allExpired
        ? 'Đơn này đã hết bảo hành, nhưng đã được lưu vào hồ sơ của bạn.'
        : records.length + ' sản phẩm trong đơn đã được bảo hành thành công.';
    }
    const wid = document.getElementById('success-wid');
    if (wid) wid.textContent = ar.warranty_code || S.warrantyId || '—'; // mã SERVER cấp

    // Các dòng thông tin trên phiếu bảo hành điện tử (v5.1). Khách vừa tự nhập
    // tên/SĐT nên hiện nguyên văn cho chính họ xem — không phải dữ liệu mask.
    const cust = S.customer || {};
    const order = (S.lookupResult && S.lookupResult.order) || {};
    const setText = function (id, value) {
      const el = document.getElementById(id);
      if (el) el.textContent = value;
    };
    setText('success-customer', cust.full_name || order.masked_name || 'Khách hàng Ajido');
    setText('success-phone', cust.phone || order.masked_phone || '—');
    // Token NOCODE- là mã nội bộ client sinh cho nhánh "không có mã đơn" —
    // không hiện ra phiếu (cùng lý do đã ghi ở renderDetail).
    const orderEl = document.getElementById('success-order');
    if (orderEl) {
      orderEl.innerHTML = (S.ref && /^NOCODE-/.test(S.ref))
        ? 'Tự đăng ký — không có mã đơn'
        : channelBadge(order) + (S.ref ? ' · ' + escapeHtml(S.ref) : '');
    }
    setText('success-date', formatDate(new Date().toISOString()));

    const box = document.getElementById('success-products');
    if (!box) return;
    let html = '';
    for (const r of records) {
      const badge = r.is_expired_at_activation
        ? '<span class="w5-badge w5-badge--exp">Hết hạn</span>'
        : '<span class="w5-badge w5-badge--ok">Còn hạn</span>';
      const meta = r.is_expired_at_activation
        ? 'Đã hết bảo hành — vẫn lưu vào hồ sơ'
        : 'Bảo hành đến ' + formatDate(r.warranty_end) + ' · còn ' + r.days_remaining + ' ngày';
      html += '<div class="w5-item">' + itemThumb(r)
        + '<div class="w5-item-b"><div class="w5-item-t">' + escapeHtml(r.product_name || r.product_code) + ' ' + badge + '</div>'
        + '<div class="w5-item-m">' + escapeHtml(meta) + '</div></div></div>';
    }
    box.innerHTML = html;
  }

  document.getElementById('restart-link')?.addEventListener('click', function (e) {
    e.preventDefault();
    resetActivation();
    if (refInput) refInput.value = '';
    saveState();
    setHash('#kich-hoat');
  });

  /* ===== LUỒNG TRA CỨU (MỚI — contract /search) ========================== */
  const searchForm = document.getElementById('search-form');

  searchForm?.addEventListener('submit', function (e) {
    e.preventDefault();
    doSearch(document.getElementById('search-input')?.value || '');
  });

  function startSearch(q) {
    hideErrorModal();
    const input = document.getElementById('search-input');
    if (input) input.value = q || '';
    setHash('#tra-cuu');
    if (q) doSearch(q);
  }

  async function doSearch(qRaw) {
    const input = document.getElementById('search-input');
    const q = String(qRaw || '').trim();
    if (q.length < 3) {
      showHelperError(input, 'Vui lòng nhập ít nhất 3 ký tự');
      return;
    }

    const btn = searchForm?.querySelector('button[type="submit"]');
    btn?.classList.add('is-loading');
    if (btn) btn.disabled = true;

    try {
      const res = await apiFetch('/search?q=' + encodeURIComponent(q));
      const data = res.data || {};

      if (res.status === 429) {
        // Thông điệp trung tính từ server (chống dò quét)
        showToast((data.error && data.error.message_vi) || 'Bạn thao tác quá nhanh. Vui lòng thử lại sau ít phút.');
        return;
      }
      if (!res.ok) {
        if (data.error && data.error.code === 'INVALID_REF_FORMAT') {
          showHelperError(input, data.error.message_vi || 'Mã tra cứu không hợp lệ');
        } else {
          showToast((data.error && data.error.message_vi) || 'Có lỗi khi tra cứu. Vui lòng thử lại sau ít phút.');
        }
        return;
      }

      if (data.status === 'not_found') {
        // Empty-state trong tab — KHÔNG mở error-modal
        S.searchQuery = q; S.searchResult = data; S.detail = null;
        saveState();
        setHash('#tra-cuu'); // re-render tab hiện tại qua đường setHash duy nhất
        return;
      }

      if (data.status === 'not_registered') {
        S.searchQuery = q; S.searchResult = data;
        S.detail = { kind: 'not_registered', data: data };
        saveState();
        setHash(hashForDetail(q), { replace: true });
        return;
      }

      if (data.status === 'found') {
        S.searchQuery = q; S.searchResult = data;
        const acts = data.activations || [];
        if (acts.length === 1) {
          S.detail = { kind: 'activation', activation: acts[0] };
          saveState();
          setHash(hashForDetail(acts[0].warranty_code), { replace: true }); // 1 phiếu → thẳng chi tiết
        } else {
          S.detail = null;
          saveState();
          setHash('#ds-bao-hanh');
        }
        return;
      }

      showToast('Phản hồi không hợp lệ từ máy chủ. Vui lòng thử lại.');
    } catch (err) {
      console.error(err);
      showToast('Mất kết nối. Vui lòng thử lại.');
    } finally {
      btn?.classList.remove('is-loading');
      if (btn) btn.disabled = false;
    }
  }

  function renderSearch() {
    const fb = document.getElementById('search-feedback');
    if (!fb) return;
    const input = document.getElementById('search-input');
    if (input && !input.value && S.searchQuery) input.value = S.searchQuery;

    if (S.searchResult && S.searchResult.status === 'not_found') {
      fb.innerHTML = '<div class="w5-empty">'
        + '<div class="w5-empty-ico">' + ICON_SEARCH + '</div>'
        + '<h3>Không tìm thấy thông tin bảo hành</h3>'
        + '<p class="w5-small">' + escapeHtml(S.searchResult.message_vi || 'Không tìm thấy thông tin bảo hành cho mã đã nhập.') + '</p>'
        + '<div class="w5-empty-actions">'
        + '<button type="button" id="search-retry-btn" class="w5-btn w5-btn--ghost w5-btn--sm">Thử mã khác</button>'
        + '<a href="' + ZALO_URL + '" target="_blank" rel="noopener" class="w5-btn w5-btn--sm">Liên hệ Zalo OA</a>'
        + '</div></div>';
      document.getElementById('search-retry-btn')?.addEventListener('click', function () {
        S.searchResult = null; S.searchQuery = null;
        saveState();
        const si = document.getElementById('search-input');
        if (si) { si.value = ''; }
        setHash('#tra-cuu');
        si?.focus();
      });
    } else {
      fb.innerHTML = '';
    }
  }

  /* ----- danh sách phiếu ----- */
  function renderList() {
    const wrap = document.getElementById('search-list');
    const data = S.searchResult;
    if (!wrap || !data || data.status !== 'found') return;
    const acts = data.activations || [];

    const sub = document.getElementById('search-list-subtitle');
    if (sub) sub.textContent = 'Tìm thấy ' + acts.length + ' phiếu bảo hành. Chọn một phiếu để xem chi tiết.';

    wrap.innerHTML = acts.map(function (a, i) {
      const products = a.products || [];
      const first = products[0] ? products[0].product_name : 'Sản phẩm Ajido';
      const anyActive = products.some(function (p) { return (p.status || 'active') === 'active'; });
      const badge = anyActive
        ? '<span class="w5-badge w5-badge--ok">Còn hiệu lực</span>'
        : '<span class="w5-badge w5-badge--exp">Hết hạn</span>';
      return '<button type="button" class="w5-list-card" data-idx="' + i + '">'
        + itemThumb(products[0] || {})
        + '<div class="w5-list-card-b">'
        + '<div class="w5-list-card-t">' + escapeHtml(a.warranty_code || '—') + badge + '</div>'
        + '<div class="w5-list-card-m">' + escapeHtml(first) + ' · ' + products.length + ' sản phẩm · Đăng ký ' + formatDate(a.activated_at) + '</div>'
        + '</div>' + ICON_CHEVRON + '</button>';
    }).join('');

    wrap.querySelectorAll('.w5-list-card').forEach(function (card) {
      card.addEventListener('click', function () {
        const idx = parseInt(card.dataset.idx, 10);
        const act = ((S.searchResult && S.searchResult.activations) || [])[idx];
        if (!act) return;
        S.detail = { kind: 'activation', activation: act };
        saveState();
        setHash(hashForDetail(act.warranty_code));
      });
    });
  }

  /* ----- chi tiết phiếu ----- */
  function renderDetail() {
    const box = document.getElementById('detail-content');
    if (!box || !S.detail) return;

    if (S.detail.kind === 'not_registered') {
      renderDetailNotRegistered(box, S.detail.data);
      return;
    }

    const a = S.detail.activation || {};
    const cust = a.customer || {};
    const order = a.order || {};
    const products = a.products || [];

    // 1. Mã bảo hành (ref-card + copy)
    let html = '<div class="w5-code"><div><div class="w5-code-l">Mã bảo hành</div>'
      + '<div class="w5-code-v">' + escapeHtml(a.warranty_code || '—') + '</div></div>'
      + '<button type="button" class="w5-copy" id="copy-wid-btn">' + ICON_COPY + 'Sao chép</button></div>';

    // 2-5. Khách / đơn / ngày đặt / ngày đăng ký
    html += '<dl class="w5-rows">'
      + row('Khách hàng', (cust.masked_name || 'Khách hàng') + (cust.province ? ' · ' + cust.province : ''))
      + (cust.masked_phone ? row('SĐT đăng ký', cust.masked_phone) : '')
      + rowHtml('Đơn hàng', channelBadge(order) + (order.order_id ? ' · ' + escapeHtml(order.order_id) : ''))
      // Token NOCODE- là mã nội bộ do chính client sinh cho khách "không có mã",
      // KHÔNG phải mã vận đơn. Hiện nó ra là khách vừa khai không có mã lại thấy
      // một mã lạ trên phiếu, gọi CSKH hỏi và CSKH tra sàn không ra gì.
      + (order.external_ref && order.external_ref !== order.order_id
          && !/^NOCODE-/.test(order.external_ref)
          ? row('Mã vận đơn', order.external_ref) : '')
      + row('Ngày đặt hàng', a.order_date ? formatDate(a.order_date) : '—')
      + row('Ngày đăng ký bảo hành', a.activated_at ? formatDate(a.activated_at) : '—')
      + '</dl>';

    // 6-7. Sản phẩm + khối hạn bảo hành
    html += '<span class="w5-eyebrow" style="margin-bottom:4px">' + products.length + ' sản phẩm</span>';
    for (const p of products) {
      const st = productStatus(p);
      const w = p.warranty || {};
      const display = w.display || warrantyDisplayFallback(w);
      html += '<div class="w5-item">' + itemThumb(p)
        + '<div class="w5-item-b">'
        + '<div class="w5-item-t">' + escapeHtml(p.product_name || p.product_code || 'Sản phẩm Ajido')
        + ' <span class="w5-badge ' + st.badge + '">' + st.label + '</span></div>'
        + (p.product_code ? '<div class="w5-item-m">' + escapeHtml(p.product_code) + '</div>' : '')
        + '<div class="w5-wbox ' + st.box + '">' + escapeHtml(display) + '</div>'
        + '</div></div>';
    }

    html += '<div class="w5-link-row w5-no-print"><button type="button" class="w5-link" id="print-detail-btn">In phiếu bảo hành</button></div>';

    box.innerHTML = html;

    document.getElementById('copy-wid-btn')?.addEventListener('click', async function () {
      try {
        await navigator.clipboard.writeText(a.warranty_code || '');
        showToast('Đã sao chép mã bảo hành');
      } catch (e) {
        showToast('Không sao chép được — vui lòng chọn và copy thủ công');
      }
    });
    document.getElementById('print-detail-btn')?.addEventListener('click', function () { window.print(); });
  }

  function renderDetailNotRegistered(box, data) {
    const order = data.order || {};
    const action = data.action || {};

    let html = '<div class="w5-code w5-code--fill"><div><div class="w5-code-l">Đơn hàng</div>'
      + '<div class="w5-code-v w5-code-v--sm">' + channelBadge(order) + (order.order_id ? ' · ' + escapeHtml(order.order_id) : '') + '</div></div>'
      + '<span class="w5-badge w5-badge--pend">Chưa đăng ký</span></div>';

    html += '<dl class="w5-rows">'
      + row('Ngày giao', order.delivered_on ? formatDate(order.delivered_on) : '—')
      + row('Trạng thái', 'Chưa đăng ký bảo hành')
      + '</dl>';

    html += '<p class="w5-small" style="margin-bottom:24px">'
      + escapeHtml(data.message_vi || 'Đơn này chưa được đăng ký bảo hành.') + '</p>';

    if (action.type === 'switch_to_activate' && action.ref) {
      html += '<button type="button" id="detail-activate-btn" class="w5-btn w5-btn--w">'
        + escapeHtml(action.label_vi || 'Kích hoạt bảo hành cho đơn này') + '</button>';
    }

    box.innerHTML = html;

    document.getElementById('detail-activate-btn')?.addEventListener('click', function () {
      switchToActivate(action.ref);
    });
  }

  // Chuyển sang tab kích hoạt và tra lại đơn bằng action.ref (contract not_registered)
  function switchToActivate(ref) {
    if (refInput) refInput.value = ref || '';
    setHash('#kich-hoat');
    if (ref) doLookup(ref);
  }

  /* ===== Quét mã — uỷ cho warranty-scan.js ============================== */
  /**
   * opts.hint     — dòng chữ dưới khung ngắm
   * opts.focusId  — ô nhập được đưa con trỏ vào khi khách phải gõ tay
   * opts.showGuide— chỉ nút quét MÃ ĐƠN mới bung hoạt ảnh phiếu; nút quét
   *                 barcode sản phẩm thì không, vì hoạt ảnh dạy tìm mã trên
   *                 phiếu giao hàng, chẳng liên quan tới hộp sản phẩm.
   * opts.formats  — danh sách format cho BarcodeDetector/ZXing; không truyền
   *                 thì warranty-scan.js tự rơi về DEFAULT_FORMATS.
   */
  function scanInto(opts, onValue) {
    if (!window.AjidoScan) { showToast('Chưa nạp được bộ quét. Vui lòng nhập tay.'); return; }

    window.AjidoScan.openScanner({ hint: opts.hint, formats: opts.formats }).then(function (r) {
      if (r.status === 'ok') { onValue(r.value); return; }
      if (r.status === 'cancelled') { return; }

      // manual / no_camera / denied / not_found / not_readable / decoder_failed /
      // overlay_error đều dẫn về cùng một chỗ: gõ tay.
      var msg = {
        no_camera: 'Máy không mở được camera. Anh/chị nhập mã tay giúp em.',
        denied: 'Chưa được cấp quyền camera. Anh/chị nhập mã tay giúp em.',
        not_found: 'Máy này không tìm thấy camera. Anh/chị nhập mã tay giúp em.',
        not_readable: 'Camera đang được ứng dụng khác sử dụng. Đóng ứng dụng đó rồi thử lại, hoặc nhập mã tay giúp em.',
        decoder_failed: 'Không tải được bộ quét. Anh/chị nhập mã tay giúp em.',
        overlay_error: 'Có lỗi khi mở camera. Anh/chị nhập mã tay giúp em.',
      }[r.reason];
      if (msg) { showToast(msg, 4000); }
      if (opts.showGuide) { window.AjidoScan.guide.open(document); }
      document.getElementById(opts.focusId)?.focus();
    });
  }

  document.getElementById('qr-scan-btn')?.addEventListener('click', function () {
    scanInto(
      { hint: 'Đưa mã vạch dài trên phiếu vào khung', focusId: 'ref-input', showGuide: true },
      function (code) {
        if (refInput) { refInput.value = code; }
        doLookup(code);
      }
    );
  });

  async function resolveBarcodeToProduct(barcode) {
    try {
      const res = await apiFetch('/barcode/' + encodeURIComponent(barcode));
      const data = res.data || {};
      if (data.found) {
        // Có danh mục → chọn luôn dòng tương ứng (kèm ảnh); không thì điền ô gõ tay.
        if (!(PRODUCTS && data.product_code && pickProduct(data.product_code))) {
          const input = document.getElementById('product_name_input');
          if (input) input.value = data.product_name;
        }
        showToast('Đã nhận: ' + data.product_name);
      } else {
        showToast('Barcode ' + barcode + ' không có trong hệ thống');
      }
    } catch (err) {
      showToast('Lỗi tra cứu barcode');
    }
  }

  /* ===== Error modal ===================================================== */
  const errorModal = document.getElementById('error-modal');

  function showError(opts) {
    const o = opts || {};
    const t = document.getElementById('error-title');
    if (t) t.textContent = o.title || 'Có lỗi xảy ra';
    const m = document.getElementById('error-message');
    if (m) m.textContent = o.message || '';

    const actBtn = document.getElementById('error-action-btn');
    if (actBtn) {
      actBtn.hidden = !o.action;
      if (o.action) {
        actBtn.textContent = o.action.label;
        actBtn.onclick = function () {
          hideErrorModal();
          if (o.action.onClick) o.action.onClick();
        };
      } else {
        actBtn.onclick = null;
      }
    }

    const cskBtn = document.getElementById('error-csk-btn');
    if (cskBtn) {
      cskBtn.hidden = !o.showCsk;
      if (o.showCsk) cskBtn.href = ZALO_URL;
    }

    if (errorModal) errorModal.hidden = false;
  }

  function hideErrorModal() {
    if (errorModal) errorModal.hidden = true;
  }

  document.getElementById('error-close-btn')?.addEventListener('click', hideErrorModal);
  errorModal?.addEventListener('click', function (e) {
    if (e.target === errorModal) hideErrorModal(); // bấm nền mờ để đóng
  });

  /* ===== Toast =========================================================== */
  const toast = document.getElementById('toast');
  let toastTimer = null;

  function showToast(msg, ms) {
    if (!toast) return;
    toast.textContent = msg;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, ms || 3000);
  }

  /* ===== Helpers ========================================================= */
  function row(label, value) {
    return '<div class="w5-row"><dt>' + escapeHtml(label) + '</dt><dd>' + escapeHtml(value) + '</dd></div>';
  }

  /** Như row() nhưng value là HTML đã an toàn (badge kênh, mã đã escape...). */
  function rowHtml(label, valueHtml) {
    return '<div class="w5-row"><dt>' + escapeHtml(label) + '</dt><dd>' + valueHtml + '</dd></div>';
  }

  /** Nhãn kênh kèm icon thương hiệu; kênh lạ vẫn ra nhãn chữ + icon túi trung tính. */
  function channelBadge(order) {
    const label = channelLabel(order);
    const key = order && order.channel ? String(order.channel) : '';
    const icon = CHANNEL_ICONS[key] || ICON_CHANNEL_DEFAULT;
    const cls = key ? ' w5-chan--' + key.replace(/[^a-z0-9_-]/gi, '') : '';
    return '<span class="w5-chan' + cls + '">' + icon + escapeHtml(label) + '</span>';
  }

  /**
   * Ô ảnh sản phẩm: có image_url (https, do API chuẩn hoá từ warranty_policy)
   * → <img>; không có → icon hộp như trước. Ảnh lỗi tải → onImageError đổi
   * lại icon để không có ô trống.
   */
  function itemThumb(p) {
    const url = p && typeof p.image_url === 'string' ? p.image_url.trim() : '';
    if (/^https:\/\//i.test(url)) {
      return '<div class="w5-item-ico w5-item-ico--img"><img src="' + escapeHtml(url) + '" alt="" loading="lazy" width="52" height="52"></div>';
    }
    return '<div class="w5-item-ico">' + ICON_BOX + '</div>';
  }

  function onImageError(e) {
    const t = e && e.target;
    if (!t || String(t.tagName || '').toUpperCase() !== 'IMG' || typeof t.closest !== 'function') return;
    const ico = t.closest('.w5-item-ico');
    if (!ico) return;
    ico.classList.remove('w5-item-ico--img');
    ico.innerHTML = ICON_BOX;
  }

  function channelLabel(order) {
    if (!order) return 'Đơn hàng';
    const label = order.channel_label || CHANNEL_MAP[order.channel];
    // Loại ref `unknown` — không hiện chữ "unknown" cho khách
    if (label && String(label).toLowerCase() !== 'unknown') return label;
    return 'Đơn hàng';
  }

  function productStatus(p) {
    const st = p.status || ((p.warranty && p.warranty.is_expired) ? 'expired' : 'active');
    if (st === 'active') return { badge: 'w5-badge--ok', label: 'Còn hiệu lực', box: 'w5-wbox--ok' };
    if (st === 'expired') return { badge: 'w5-badge--exp', label: 'Đã hết hạn', box: 'w5-wbox--warn' };
    return { badge: 'w5-badge--pend', label: 'Không hiệu lực', box: 'w5-wbox--mute' }; // voided...
  }

  function warrantyDisplayFallback(w) {
    if (!w || !w.end) return 'Chưa có thông tin thời hạn';
    if (w.is_expired) return 'Đã hết bảo hành ngày ' + formatDate(w.end);
    return (w.months ? w.months + ' tháng · ' : '') + 'còn ' + (w.days_remaining != null ? w.days_remaining : '—') + ' ngày · đến ' + formatDate(w.end);
  }

  function normalizeVNPhone(raw) {
    if (!raw) return null;
    let p = String(raw).replace(/[\s.\-()]/g, '');
    if (/^\+84\d{9}$/.test(p)) p = '0' + p.slice(3);
    else if (/^84\d{9}$/.test(p)) p = '0' + p.slice(2);
    return /^0(3|5|7|8|9)\d{8}$/.test(p) ? p : null;
  }

  function isPhoneLike(q) {
    return !!normalizeVNPhone(q);
  }

  function todayStr() {
    return new Date().toISOString().slice(0, 10);
  }

  function formatDate(iso) {
    if (!iso) return '';
    const dateOnly = String(iso).slice(0, 10); // nhận cả ISO timestamp
    const d = dateOnly.split('-');
    if (d.length !== 3) return String(iso);
    return d[2] + '/' + d[1] + '/' + d[0];
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function showHelperError(input, msg) {
    if (!input) { showToast(msg); return; }
    input.classList.add('error');
    const fieldEl = input.closest('.w5-field');
    let hint = fieldEl ? fieldEl.querySelector('.w5-hint') : null;
    if (!hint && fieldEl) {
      hint = document.createElement('p');
      hint.className = 'w5-hint';
      fieldEl.appendChild(hint);
    }
    if (hint) {
      if (!hint.dataset.orig) hint.dataset.orig = hint.textContent;
      hint.classList.add('error');
      hint.textContent = msg;
    }
    setTimeout(function () {
      input.classList.remove('error');
      if (hint) {
        hint.classList.remove('error');
        hint.textContent = hint.dataset.orig || '';
      }
    }, 4000);
  }

  /* ===== MOCK DATA (đúng shape contract — chỉ dùng khi USE_MOCK=true) ==== */
  const MOCK_ACT_1 = {
    warranty_code: 'WAJ-2026-7K3M9P',
    customer: { masked_name: 'Nguyễn V** A**', masked_phone: '098****321', province: 'Hà Nội' },
    order: { order_id: '260515F2BY3X6V', channel: 'shopee', channel_label: 'Shopee', external_ref: 'VN261059728287N' },
    order_date: '2026-05-15',
    activated_at: '2026-05-20T09:31:02.114Z',
    products: [
      {
        product_code: 'S5 PRO', product_name: 'Cân sức khoẻ Ajido S5 Pro', status: 'active', image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/Image_20240426164127.png?v=1763724034&width=160',
        warranty: { months: 12, start: '2026-05-18', end: '2027-05-18', days_remaining: 273, is_expired: false, display: '12 tháng · còn 273 ngày · đến 18/05/2027' },
      },
    ],
  };
  const MOCK_ACT_2 = {
    warranty_code: 'WAJ-2025-Q2XD7N',
    customer: { masked_name: 'Nguyễn V** A**', masked_phone: '098****321', province: 'Hà Nội' },
    order: { order_id: '251103TTSX91KA', channel: 'tiktok_shop', channel_label: 'TikTok Shop', external_ref: 'SPXVN0512345678' },
    order_date: '2025-11-03',
    activated_at: '2025-11-08T14:02:11.000Z',
    products: [
      {
        product_code: 'MINI Q5', product_name: 'Máy massage Ajido Mini Q5', status: 'expired', image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/Q5.193.png?v=1775101777&width=160',
        warranty: { months: 12, start: '2025-11-06', end: '2026-02-03', days_remaining: 0, is_expired: true, display: 'Đã hết bảo hành ngày 03/02/2026' },
      },
      {
        product_code: 'H5 PRO', product_name: 'Máy massage cổ Ajido H5 Pro', status: 'active', image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/z6980264050294_6634daf6b54cae28ddb22a9175713b19_f4f57881-4685-4b18-91d6-9afcc80907fc.jpg?v=1757065426&width=160',
        warranty: { months: 12, start: '2025-11-06', end: '2026-11-06', days_remaining: 80, is_expired: false, display: '12 tháng · còn 80 ngày · đến 06/11/2026' },
      },
    ],
  };
  const MOCKS = {
    lookup_found: {
      status: 'found', ref_type: 'tracking_number', order: {
        order_id: '260812TTSX45QP', channel: 'tiktok_shop', delivered_on: '2026-08-12',
        masked_name: 'Nguyễn V** A**', masked_phone: '0*******21', province: 'TP. Hồ Chí Minh',
        items: [
          { product_code: 'S5 PRO', product_name: 'Cân sức khoẻ Ajido S5 Pro', warranty_months: 12, warranty_end: '2027-08-12', days_remaining: 359, expired: false, image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/Image_20240426164127.png?v=1763724034&width=160' },
          { product_code: 'MINI Q5', product_name: 'Máy massage Ajido Mini Q5', warranty_months: 12, warranty_end: '2026-02-03', days_remaining: 0, expired: true, image_url: null },
        ],
      },
    },
    lookup_blocked: {
      status: 'blocked', blocked_reason: 'already_activated',
      message_vi: 'Đơn này đã được kích hoạt bảo hành ngày 20/05/2026. Liên hệ CSKH nếu bạn cho rằng đây là nhầm lẫn.',
      data: { activated_on: '2026-05-20', masked_phone: '0*******21', warranty_code: 'WAJ-2026-7K3M9P', records_count: 2 },
      action: { type: 'switch_to_search', q: 'WAJ-2026-7K3M9P', label_vi: 'Xem phiếu bảo hành' },
    },
    lookup_not_found: { status: 'not_found', message_vi: 'Không tìm thấy đơn trong hệ thống.' },
    activate_ok: {
      status: 'activated', warranty_code: 'WAJ-2026-7K3M9P',
      warranty_records: [
        { product_code: 'S5 PRO', product_name: 'Cân sức khoẻ Ajido S5 Pro', warranty_end: '2027-08-18', days_remaining: 365, is_expired_at_activation: false, image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/Image_20240426164127.png?v=1763724034&width=160' },
        { product_code: 'MINI Q5', product_name: 'Máy massage Ajido Mini Q5', warranty_end: '2026-02-03', days_remaining: 0, is_expired_at_activation: true, image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/Q5.193.png?v=1775101777&width=160' },
      ],
    },
    search_single: { status: 'found', ref_type: 'warranty_code', count: 1, activations: [MOCK_ACT_1], request_id: 'mock-1' },
    search_multi: { status: 'found', ref_type: 'phone', count: 2, activations: [MOCK_ACT_1, MOCK_ACT_2], request_id: 'mock-2' },
    search_not_registered: {
      status: 'not_registered', ref_type: 'order_ref',
      order: { order_id: '260515F2BY3X6V', channel: 'shopee', channel_label: 'Shopee', delivered_on: '2026-05-18', eligible: true },
      action: { type: 'switch_to_activate', ref: 'VN261059728287N', label_vi: 'Kích hoạt bảo hành cho đơn này' },
      message_vi: 'Đơn này chưa được đăng ký bảo hành.', request_id: 'mock-3',
    },
    search_not_found: { status: 'not_found', message_vi: 'Không tìm thấy thông tin bảo hành cho mã đã nhập.', request_id: 'mock-4' },
    barcode_found: { found: true, product_code: 'S5 PRO', product_name: 'Cân S5 PRO' },
    products: {
      products: [
        { product_code: 'S5 PRO', product_name: 'Cân S5 PRO', warranty_months: 12, image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/Image_20240426164127.png?v=1763724034&width=160' },
        { product_code: 'X8 ELITE', product_name: 'Cân ScanBody X8 ELITE', warranty_months: 18, image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/x8-elite.png?v=1749279198&width=160' },
        { product_code: 'S8', product_name: 'Cân ScanBody S8', warranty_months: 18, image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/Black.png?v=1749715554&width=160' },
        { product_code: 'MINI Q6 STD', product_name: 'Máy massage Mini Q6 tiêu chuẩn', warranty_months: 12, image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/01.png?v=1754731122&width=160' },
        { product_code: 'MINI Q5', product_name: 'Máy massage Mini Q5', warranty_months: 12, image_url: 'https://cdn.shopify.com/s/files/1/0759/0625/3050/files/Q5.193.png?v=1775101777&width=160' },
        { product_code: 'MH48', product_name: 'AJ-MH48 không dây', warranty_months: 12, image_url: null },
      ],
      request_id: 'mock-products',
    },
  };

  function mockApi(path) {
    const respond = function (data, ok, status) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve({ ok: ok !== false, status: status || 200, data: data });
        }, 350);
      });
    };
    const qMatch = /[?&](?:q|ref)=([^&]*)/.exec(path);
    const q = qMatch ? decodeURIComponent(qMatch[1]).toUpperCase() : '';

    if (path.indexOf('/lookup') === 0) {
      if (q.indexOf('DAKICHHOAT') >= 0) return respond(MOCKS.lookup_blocked);
      if (q.indexOf('KHONGCO') >= 0) return respond(MOCKS.lookup_not_found);
      return respond(MOCKS.lookup_found);
    }
    if (path.indexOf('/zalo/lead/') === 0) return respond({ full_name: 'Nguyễn Văn A', phone: '0987654321' });
    if (path.indexOf('/activate') === 0) return respond(MOCKS.activate_ok);
    if (path.indexOf('/barcode/') === 0) return respond(MOCKS.barcode_found);
    if (path.indexOf('/products') === 0) return respond(MOCKS.products);
    if (path.indexOf('/search') === 0) {
      if (/^WAJ-/.test(q)) return respond(MOCKS.search_single);
      if (isPhoneLike(q)) return respond(MOCKS.search_multi);
      if (q.indexOf('KHONGCO') >= 0) return respond(MOCKS.search_not_found);
      return respond(MOCKS.search_not_registered);
    }
    return respond({ error: { message_vi: 'Mock: không có route ' + path } }, false, 404);
  }

  /* ===== Boot ============================================================ */
  app.addEventListener('error', onImageError, true); // ảnh sản phẩm hỏng → icon hộp
  window.addEventListener('hashchange', function () { routeToState(); });
  loadState();
  captureZaloLead();
  routeToState();

})();
